(function ($) {
  Drupal.behaviors.helpMenuV1 = {
    attach: function (context, settings) {
      var self = this;

      $('.help-menu-v1').each(function () {
        var $tmpl = $(this);
      });
    }
  };
})(jQuery);
